import React from 'react';
import { Box, CircularProgress, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
	container: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}));

// Default
// Circular Loader
const Loader = (props) => {
	const classes = useStyles();
	const { show, height, width, border, borderRadius } = props;
	return show ? (
		<Box className={classes.container} style={{ height, width, border, borderRadius }}>
			<CircularProgress />
		</Box>
	) : null;
};

Loader.propTypes = {
	show: PropTypes.bool,
	width: PropTypes.string.isRequired,
	height: PropTypes.string,
	border: PropTypes.string,
	borderRadius: PropTypes.string
};

Loader.defaultProps = {
	show: true,
	height: 'auto',
	width: 'auto',
	border: '0px',
	borderRadius: '0px'
};

export default Loader;
